import * as React from 'react';
import { IQuadrantReportSettings } from '../../../../data/providers/settings/reports/quadrantReportSettingsProvider';
import {
  ISelectableMetric,
  ISelectableTag,
  ISelectableTestType,
} from '../../../../data/types';
import { CardHeader, CardHeaderLeft } from '../../../shared/card/CardHeader';
import { ControlLabel } from '../../../shared/form/ControlLabel';
import { ControlSpacer } from '../../../shared/form/ControlSpacer';
import { SingleMetricSelect } from '../../../shared/form/selects/SingleMetricSelect';
import { TagSelect } from '../../../shared/form/selects/TagsSelect';
import { TestTypeSelect } from '../../../shared/form/selects/TestTypeSelect';
import { Step } from '../../../shared/form/Step';
import { FormSection } from '../../utils/settings/FormSection';

interface IProps {
  axisName: 'xAxis' | 'yAxis';
  settings: IQuadrantReportSettings;
  onSettingsChange: (settings: IQuadrantReportSettings) => void;
  step: number;
}

export const AxisForm = (props: IProps): React.ReactElement => {
  const axisSettings = props.settings?.[props.axisName];
  /**
   * @description handles test type selection
   * @param testType
   */
  const testTypeChangeHandler = (
    testType: ISelectableTestType | ISelectableTestType[]
  ): void => {
    props.onSettingsChange({
      ...props?.settings,
      [props.axisName]: {
        testType: testType as ISelectableTestType,
        tags: [],
        metric: null,
      },
    });
  };

  /**
   * @description handles tag selection
   * @param tags
   */
  const tagsChangeHandler = (tags: ISelectableTag[]): void => {
    props.onSettingsChange({
      ...props?.settings,
      [props.axisName]: {
        ...axisSettings,
        tags,
      },
    });
  };

  /**
   * @description handles metric selection
   * @param metric
   */
  const metricChangeHandler = (metric: ISelectableMetric): void => {
    props.onSettingsChange({
      ...props?.settings,
      [props.axisName]: {
        ...axisSettings,
        metric,
      },
    });
  };

  return (
    <FormSection>
      <CardHeader>
        <CardHeaderLeft>
          <Step>{props.step}</Step>
          <h6>Select {props.axisName} Metric</h6>
        </CardHeaderLeft>
      </CardHeader>
      <div style={{ padding: '10px' }}>
        <ControlSpacer>
          <ControlLabel>Test Type</ControlLabel>
          <TestTypeSelect
            value={axisSettings?.testType}
            onChange={testTypeChangeHandler}
            disabled={false}
            allowMultiple={false}
          />
        </ControlSpacer>
        <ControlSpacer>
          <ControlLabel>Tags</ControlLabel>
          <TagSelect
            value={axisSettings?.tags}
            onChange={tagsChangeHandler}
            disabled={!axisSettings?.testType}
          />
        </ControlSpacer>
        <ControlSpacer>
          <ControlLabel>Metric</ControlLabel>
          <SingleMetricSelect
            excludeAsymmetry
            testTypeId={axisSettings?.testType?.value}
            disabled={!axisSettings?.testType}
            value={axisSettings?.metric}
            onChange={metricChangeHandler}
          />
        </ControlSpacer>
      </div>
    </FormSection>
  );
};
